import Vue from 'vue'
import waves from './waves/index'

// 全局使用自定义指令
Vue.use(waves);





// WEBPACK FOOTER //
// ./src/directive/index.js